import React, { CSSProperties, FC, useState } from "react"
import Styles from "../styles/MyImage.module.scss";
import getNewPathAvoidingCache from "../functions/getNewPathAvoidingCache"
import Modal from "./Modal"

type Props = {
    file: string
    imageStyle?: CSSProperties
}

const ImageComponent: FC<Props> = ( {
    file,
    imageStyle = {}
} ) => {

    const [ modalVisible, setModalVisible ] = useState( false );

    return (
        <div
            className={ Styles.container }>
            <img
                className={ Styles.image }
                onClick={ () => setModalVisible( true ) }
                src={ file }
                style={ imageStyle }
                onError={ ( e ) => getNewPathAvoidingCache( e.target as HTMLImageElement ) } />
            { modalVisible &&
                <Modal
                    closeModal={ () => setModalVisible( false ) }
                    visible={ true }
                    swipeToClose={ true }>
                    <div className={ Styles.modal_image_wrapper }>
                        <img
                            className={ Styles.modal_image }
                            src={ file }
                            onError={ ( e ) => getNewPathAvoidingCache( e.target as HTMLImageElement ) } />
                    </div>
                </Modal> }
        </div> )
}

export default ImageComponent
